<template>
    <div>
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <textarea-form-group
                v-model="data.text"
                name="text"
                label="Text"
                :error="(errors.text || [])[0]"
        />

        <div v-for="(element, index) in data.elements"
             style="border: 1px solid black; border-radius: 15px; padding: 15px; margin-bottom: 15px">
            <text-form-group
                    v-model="element.headline"
                    name="headline"
                    label="Headline"
                    :error="(errors['elements.' + index + '.headline'] || [])[0]"
            />

            <ck-editor-form-group
                    v-model="element.text"
                    name="text"
                    label="Text"
                    :error="(errors['elements.' + index + '.text'] || [])[0]"
            />

            <select-form-group
                    v-model="element.icon"
                    name="icon"
                    label="Icon"
                    :error="(errors['elements.' + index + '.icon'] || [])[0]"
                    :options="iconOptions"
            />

            <text-form-group
                    v-model="element.url"
                    name="url"
                    label="URL"
                    :error="(errors['elements.' + index + '.url'] || [])[0]"
            />

            <button type="button" class="btn btn-link btn-block" @click="removeElement(index)">
                <i class="fa fa-minus"/> Remove Element
            </button>
        </div>

        <button type="button" class="btn btn-black btn-block" style="margin-bottom: 15px;" @click="addElement">
            <i class="fa fa-plus"/> Add Element
        </button>
    </div>
</template>

<script>
    import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
    import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'

    export default {
        components: {CkEditorFormGroup, SelectFormGroup, TextFormGroup, TextareaFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            },

            iconOptions() {
                return [
                    {value: 'briefcase', label: 'Briefcase'},
                    {value: 'gift', label: 'Gift'},
                    {value: 'mail', label: 'Mail'},
                    {value: 'map', label: 'Map'},
                    {value: 'newspaper', label: 'Newspaper'},
                    {value: 'office-building', label: 'Office Building'},
                    {value: 'phone', label: 'Phone'},
                    {value: 'photograph', label: 'Photograph'},
                    {value: 'presentation-chart-bar', label: 'Presentation Chart Bar'},
                    {value: 'shopping-cart', label: 'Shopping Cart'},
                    {value: 'speakerphone', label: 'Speakerphone'},
                    {value: 'star', label: 'Start'},
                    {value: 'user-group', label: 'User Group'},
                    {value: 'users', label: 'Users'},
                    {value: 'video-camera', label: 'Video Camera'}
                ]
            }
        },

        methods: {
            addElement() {
                let elements = this.data.elements || []

                elements.push({driver_parameters: {}})

                this.$emit('input', {...this.value, elements})
            },

            removeElement(index) {
                let elements = this.data.elements || []

                elements.splice(index, 1)

                this.$emit('input', {...this.value, elements})
            }
        }
    }
</script>
